var React = require('react');

function Crop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.636 14.182h1.455V8.364c0-.8-.655-1.455-1.455-1.455H9.818v1.455h5.818v5.818zm-7.272 1.454V4H6.909v2.91H4v1.454h2.91v7.272c0 .8.654 1.455 1.454 1.455h7.272V20h1.455v-2.91H20v-1.454H8.364z","fill":"currentColor","fillRule":"nonzero"}));
}

Crop.defaultProps = {"viewBox":"0 0 24 24","width":"24","height":"24"};

module.exports = Crop;

Crop.default = Crop;
